module.exports = __webpack_public_path__ + "img/INYO_ROUND.50451657.png";